import get from 'lodash.get';

const monthNames = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const noResultsTmpl = `
<p id="no-hits">
  We didn't find any products for your search.<br>Try broadening your search.
</p>
`;

const hitPaths = {
  date: 'fragments.resource.resourceDateAdded.value',
  expertLevel: '_highlightResult.fragments.expert.expertLevel.value.value',
  type: '_highlightResult.fragments.resource.resourceType.value.value'
};

/**
 * Mandatory options: el, tmpl, hits
 * @param {Object} options
 */
export default class Hits {
  constructor(options) {
    Object.assign(this, options);
    this.html = '';
  }

  /**
   * Formats a given string into something usable as a class name
   * @param {String} name
   * @returns {String}
   */
  formatClass(name) {
    return name.replace(' ', '-').toLowerCase();
  }

  /**
   * Formats a Date() object into a readable string
   * @param {Object} obj
   * @returns {String}
   */
  formatDateObject(obj) {
    const day = obj.getDate();
    const monthIndex = obj.getMonth();
    const year = obj.getFullYear();

    return `${day} ${monthNames[monthIndex]} ${year}`;
  }

  /**
   * Formats a string object '2019-10-07' into a something more readable
   * @param {String} str
   * @returns {String}
   */
  formatDateString(str) {
    const [dateStr] = str.split('T');
    const [year, monthIndex, day] = dateStr.split('-');

    return `${day} ${monthNames[monthIndex - 1]} ${year}`;
  }

  /**
   * Called by the renderer to get the ball rolling
   */
  render() {
    if (this.hits.length === 0) {
      this.html = noResultsTmpl;
    } else {
      this.hits.forEach(this.renderHit.bind(this));
    }

    this.el.html(this.html);
  }

  /**
   * Takes an Algolia hit object and adds some custom properties
   * before rendering
   * @param {Object} hit
   */
  renderHit(hit) {
    const type = get(hit, hitPaths.type, false);
    const expertLevel = get(hit, hitPaths.expertLevel, false);

    if (type) {
      const date = get(hit, hitPaths.date, new Date());
      hit.resourceType = this.formatClass(type);
      hit.formattedDate = (typeof date === 'string') ? this.formatDateString(date) : this.formatDateObj(date);
    }

    if (expertLevel) {
      hit.expertLevelClassname = this.formatClass(expertLevel);
    }

    this.html += this.tmpl.render(hit);
  }
}
